import {
  reducer as creeps,
  State as CreepsState,
  selectLevel as _selectLevel,
  selectCreeps as _selectCreeps
} from './creeps.reducer';

import {
  reducer as creep,
  State as CreepState,
  selectActions as _selectActions
} from './creep.reducer';

export interface AppState {
  creeps: CreepsState;
  creep: CreepState;
}

export const initialState = {
  creeps,
  creep
};

export const selectLevel = (state: AppState) => _selectLevel(state.creeps);
export const selectCreeps = (state: AppState) => _selectCreeps(state.creeps);
export const selectCreepActions = (state: AppState) => _selectActions(state.creep);



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/store.module/app.reducer.ts